import React, { useState } from "react";
import { Card, Row, Col, Button, ButtonGroup, InputGroup, Form } from "react-bootstrap";
import * as Icons from "react-feather";
import moment from "moment";
import Axios from "axios";
import { urlAPI } from "Common";

export default function Step4Page(props) {
  const {
    dataStep1,
    dataStep2,
    dataStep3,
    dataStep4,
    setDataStep4,
    dataRujukan,
    handlePrev,
    handleSave,
    loadingSave,
    setSEP,
    SEP,
  } = props;
  console.log("dataStep1 ", dataStep1);
  console.log("dataStep2 ", dataStep2);
  console.log("dataStep3 ", dataStep3);
  console.log("dataStep4 ", dataStep4);

  
  const [isEditingPhone, setIsEditingPhone] = React.useState(false);
  const phoneRef = React.useRef(null);
  const [loadingSavePhone, setLoadingSavePhone] = useState(false);

  const handleSavePhone = () => {
    if (!isValidPhone(dataStep4?.tlp)) return; 
    setLoadingSavePhone(true);
    Axios.post(`${urlAPI}/public/regonline/updatephone`, {
      norm: dataStep3?.norm,
      tlp: dataStep4?.tlp,
    })
      .then((res) => {
        console.log("Update phone success:", res.data);
        setIsEditingPhone(false);
        // alert("Nomor telepon berhasil diperbarui");
      })
      .catch((err) => {
        console.error("Update phone error:", err);
        // alert("Gagal update nomor telepon");
      })
      .finally(() => {
        setLoadingSavePhone(false);
      });
  };

  const isValidPhone = (phone) => {
    if (!phone) return false;
    const cleaned = phone.trim();
    const regex = /^[0-9+\-\s]+$/;
    if (!regex.test(cleaned)) return false;
    const digitCount = cleaned.replace(/[^0-9]/g, "").length;
    return digitCount >= 8 && digitCount <= 14;
  };

  React.useEffect(() => {
    if (dataStep1?.sbu) {
      setDataStep4((prevData) => ({
        ...prevData,
        sbu: dataStep1.sbu,
      }));
    }
  }, [dataStep1?.sbu, setDataStep4]);

  React.useEffect(() => {
  if (dataStep3?.tlp) {
    const nohp = dataStep3.tlp.replace(/\s+/g, "");
    setDataStep4((prev) => ({
      ...prev,
      tlp: nohp,
    }));
    if (!isValidPhone(nohp)) {
      setIsEditingPhone(true);
      setTimeout(() => {
        if (phoneRef.current) phoneRef.current.focus();
      }, 100);
    }
  }
}, [dataStep3?.tlp, setDataStep4]);

  const handleEditClick = () => {
    setIsEditingPhone(true);
    setTimeout(() => {
      if (phoneRef.current) phoneRef.current.focus();
    }, 100);
  };

  return (
    <>
      <Card.Title>
        <strong>(4/4) Ringkasan</strong>
      </Card.Title>
      <br />
      <Card>
        <Card.Header>Tujuan & Waktu</Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Rumah Sakit Tujuan</Form.Label>
                  <Form.Control
                    name="sbu"
                    id="sbu"
                    type="text"
                    value={
                      dataStep1?.sbu === "RSPG"
                        ? "Rumah Sakit Petrokimia Gresik"
                        : dataStep1?.sbu === "GRAHU"
                        ? "Rumah Sakit Grha Husada"
                        : dataStep1?.sbu === "DRIYO"
                        ? "RS Petrokimia Gresik Driyorejo"
                        : dataStep1?.sbuname
                    }
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Unit Tujuan</Form.Label>
                  <Form.Control
                    name="unit"
                    id="unit"
                    type="text"
                    value={dataStep1?.unitname}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Tanggal</Form.Label>
                  <Form.Control
                    name="tgl"
                    id="tgl"
                    type="text"
                    value={moment(dataStep1?.date).format("DD-MM-YYYY")}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Dokter</Form.Label>
                  <Form.Control
                    name="namadokter"
                    id="namadokter"
                    type="text"
                    value={dataStep2?.namadokter}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Ruangan</Form.Label>
                  <Form.Control
                    name="ruang"
                    id="ruang"
                    type="text"
                    value={dataStep2?.ruang}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Jam</Form.Label>
                  <Form.Control
                    name="jam"
                    id="jam"
                    type="text"
                    value={dataStep2?.jam}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Sesi</Form.Label>
                  <Form.Control
                    name="sesi"
                    id="sesi"
                    type="text"
                    value={dataStep2?.sesi}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
      <br />
      <Card>
        <Card.Header>Data Pasien</Card.Header>
        <Card.Body>
          {dataStep1?.rs.trim() === "Belum" ? (
            <Row>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Nomor KTP</Form.Label>
                  <Form.Control
                    name="noktp"
                    id="noktp"
                    type="text"
                    value={dataStep3?.noktp}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="6" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Nama Pasien</Form.Label>
                  <Form.Control
                    name="nama"
                    id="nama"
                    type="text"
                    value={dataStep3?.nama}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Tgl Lahir</Form.Label>
                  <Form.Control
                    name="tgllahir"
                    id="tgllahir"
                    type="text"
                    value={dataStep3?.tgllahir}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Kelamin</Form.Label>
                  <Form.Control
                    name="kelamin"
                    id="kelamin"
                    type="text"
                    value={dataStep3?.tgllahir}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Alamat</Form.Label>
                  <Form.Control
                    name="alamat"
                    id="alamat"
                    type="text"
                    value={dataStep3?.alamat}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="6" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Nomor Whatsapp</Form.Label>
                  <InputGroup>
                    <Form.Control
                      ref={phoneRef}
                      name="tlp"
                      id="tlp"
                      type="text"
                      placeholder="Isikan Nomor Whatsapp Aktif"
                      value={dataStep4?.tlp || ""}
                      readOnly={!isEditingPhone}
                      onChange={(e) =>
                        setDataStep4({
                          ...dataStep4,
                          tlp: e.target.value.replace(/\s+/g, ""),
                        })
                      }
                    />
                    <InputGroup.Text
                      style={{ cursor: "pointer" }}
                      onClick={isEditingPhone ? handleSavePhone : handleEditClick}
                    >
                      {isEditingPhone ? (
                        <Icons.Check size={16} color="green" />
                      ) : (
                        <Icons.Edit size={16} />
                      )}
                    </InputGroup.Text>
                  </InputGroup>

                  {/* Pesan error */}
                  {dataStep4?.tlp && !isValidPhone(dataStep4?.tlp) && (
                    <Form.Text
                      className="text-danger d-block mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      Nomor Whatsapp tidak valid
                    </Form.Text>
                  )}

                  {/* Keterangan pensil hanya muncul kalau tidak sedang edit */}
                  {!isEditingPhone && (
                    <Form.Text
                      className={`text-muted d-block ${dataStep4?.tlp && !isValidPhone(dataStep4?.tlp) ? "mt-0" : "mt-1"}`}
                      style={{ fontSize: "12px" }}
                    >
                      *) klik pensil untuk edit/update nomor telepon
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              {dataStep1?.sbu == "DRIYO" &&
              dataStep1?.unit != "D12" &&
              dataStep1?.unit != "W06" &&
              dataStep1?.unit != "W24" ? (
                <Col lg="4" md="6" sm="12">
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      id="nomor"
                      name="nomor"
                      label={
                        <span style={{ fontWeight: "bold", color: "red" }}>
                          Informasi Penting, Kode booking yang diperoleh saat
                          daftar online tidak berlaku jika pada hari H Anda
                          mengganti jenis jaminan ke BPJS. Jika ingin
                          menggunakan BPJS, Anda perlu melakukan pendaftaran
                          online menggunakan MJKN atau daftar di loket
                          pendaftaran. Harap pastikan jenis jaminan Anda sudah
                          sesuai saat melakukan pendaftaran online. Terima kasih
                        </span>
                      }
                      checked={dataStep4?.nonBpjs === "1"}
                      onChange={(e) =>
                        setDataStep4({
                          ...dataStep4,
                          nonBpjs: e.target.checked ? "1" : "0",
                        })
                      }
                    />
                  </Form.Group>
                </Col>
              ) : (
                <></>
              )}
            </Row>
          ) : (
            <Row>
              <Col lg="6" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Nama Pasien</Form.Label>
                  <Form.Control
                    name="nama"
                    id="nama"
                    type="text"
                    value={dataStep3?.nama}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="2" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Tanggal Lahir</Form.Label>
                  <Form.Control
                    name="tgllahir"
                    id="tgllahir"
                    type="text"
                    value={moment(dataStep3?.tgllahir).format("DD-MM-YYYY")}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              {/* <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Penjamin</Form.Label>
                  <Form.Control
                    name="namacust"
                    id="namacust"
                    type="text"
                    value={dataStep3?.namacust}
                    disabled={true}
                  />
                </Form.Group>
              </Col> */}

              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Jaminan</Form.Label>
                  <Form.Control
                    name="jaminan"
                    id="jaminan"
                    type="text"
                    required="true"
                    value={dataStep3?.jaminan}
                    disabled={true}
                  />
                </Form.Group>
              </Col>

              <Col lg="6" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Nomor Asuransi</Form.Label>
                  <Form.Control
                    name="noasuransi"
                    id="noasuransi"
                    type="text"
                    required="true"
                    value={dataStep3?.noasuransi}
                    disabled={true}
                  />
                </Form.Group>
              </Col>

              <Col lg="6" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Nomor Whatsapp</Form.Label>
                  <InputGroup>
                    <Form.Control
                      ref={phoneRef}
                      name="tlp"
                      id="tlp"
                      type="text"
                      placeholder="Isikan Nomor Whatsapp Aktif"
                      value={dataStep4?.tlp || ""}
                      readOnly={!isEditingPhone}
                      onChange={(e) =>
                        setDataStep4({
                          ...dataStep4,
                          tlp: e.target.value.replace(/\s+/g, ""),
                        })
                      }
                    />
                    <InputGroup.Text
                      style={{ cursor: "pointer" }}
                      onClick={isEditingPhone ? handleSavePhone : handleEditClick}
                    >
                      {isEditingPhone ? (
                        <Icons.Check size={16} color="green" />
                      ) : (
                        <Icons.Edit size={16} />
                      )}
                    </InputGroup.Text>
                  </InputGroup>

                  {/* Pesan error */}
                  {dataStep4?.tlp && !isValidPhone(dataStep4?.tlp) && (
                    <Form.Text
                      className="text-danger d-block mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      Nomor Whatsapp tidak valid
                    </Form.Text>
                  )}

                  {/* Keterangan pensil hanya muncul kalau tidak sedang edit */}
                  {!isEditingPhone && (
                    <Form.Text
                      className={`text-muted d-block ${dataStep4?.tlp && !isValidPhone(dataStep4?.tlp) ? "mt-0" : "mt-1"}`}
                      style={{ fontSize: "12px" }}
                    >
                      *) klik pensil untuk edit/update nomor Whatsapp
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>

              <br />
              {dataStep1?.sbu == "DRIYO" &&
              dataStep1?.unit != "D12" &&
              dataStep1?.unit != "W06" &&
              dataStep1?.unit != "W24" && 
              dataStep3?.jaminan == "bpjs"
              ? (
                <Col lg="4" md="6" sm="12">
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <span
                        style={{
                          fontWeight: "bold",
                          color: "white",
                          background:
                            "linear-gradient(150deg, #56CCF2, #2F80ED)",
                          padding: "5px 10px",
                          borderRadius: "5px",
                          display: "inline-block",
                        }}
                      >
                        Pesan cinta untuk pelanggan RS Petrokimia Gresik
                        Driyorejo, jadikan daftar online RSPG Group menjadi
                        pilihan ke 2, utamakan menggunakan MJKN
                      </span>
                    </Form.Label>
                  </Form.Group>
                </Col>
              ) : (
                <></>
              )}
            </Row>
          )}
        </Card.Body>
      </Card>
      <br />
      <Row>
        <Col lg="6" md="6" className="d-none d-md-block">
          <Button
            style={{ float: "left" }}
            variant="secondary"
            disabled={loadingSave}
            onClick={() => {
              handlePrev();
            }}
          >
            <Icons.ArrowLeft size={18} />
            Kembali Pilih Dokter
          </Button>
        </Col>
        {dataStep1?.sbu == "DRIYO" &&
        dataStep1?.unit != "D12" &&
        dataStep1?.unit != "W06" &&
        dataStep1?.unit != "W24" ? (
          <Col lg="6" md="6" className="d-none d-md-block">
            <Button
              style={{ float: "right" }}
              variant="success"
              // disabled={loadingSave}
              disabled={
                dataStep4?.tlp?.trim() === "" ||
                loadingSave ||
                isEditingPhone
              }
              onClick={() => {
                handleSave();
              }}
            >
              Simpan Pendaftaran <Icons.Save size={18} />
            </Button>
          </Col>
        ) : (
          <Col lg="6" md="6" className="d-none d-md-block">
            <Button
              style={{ float: "right" }}
              variant="success"
              disabled={!isValidPhone(dataStep4?.tlp) || loadingSave || isEditingPhone}
              onClick={() => {
                handleSave();
              }}
            >
              Simpan Pendaftaran <Icons.Save size={18} />
            </Button>
          </Col>
        )}

        <Col className="d-block d-md-none" sm="12">
          <ButtonGroup style={{ width: "100%" }}>
            <Button
              variant="secondary"
              disabled={loadingSave}
              onClick={() => {
                handlePrev();
              }}
            >
              <Icons.ArrowLeft size={18} />
              Kembali
            </Button>
            &nbsp;
            {dataStep1?.sbu == "DRIYO" &&
            dataStep1?.unit != "D12" &&
            dataStep1?.unit != "W06" &&
            dataStep1?.unit != "W24" ? (
              <Button
                variant="success"
                disabled={
                  dataStep4?.tlp?.trim() === "" ||
                  loadingSave ||
                  isEditingPhone
                }
                onClick={() => {
                  handleSave();
                }}
              >
                Simpan <Icons.Save size={18} />
              </Button>
            ) : (
              <Button
                variant="success"
                disabled={!isValidPhone(dataStep4?.tlp) || loadingSave || isEditingPhone}
                onClick={handleSave}
              >
                Simpan <Icons.Save size={18} />
              </Button>
            )}
          </ButtonGroup>
        </Col>
      </Row>
    </>
  );
}